import { http } from '../../../../config/HttpCommon';

export const getTrendsById = async (wellName: string, startDate: string, endDate: string, aggregate?: string, cancelToken?: any) => {
  const response = await http.get(`/GetAssetTrendsGraphData?wellName=${encodeURIComponent(wellName)}&startDate=${startDate}&endDate=${endDate}&Aggregate=${aggregate}`, { cancelToken });
  return response.data;
};

export const getTrendsFilterData = async () => {
  const response = await http.get(`/GetAssetTrends`);
  return response.data;
}